import { jsx as _jsx } from "react/jsx-runtime";
import { createToast } from "@faire/web--source/slate/Toast/Toast";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Medium } from "@faire/web--source/ui/Typography/Span";
import truncate from "lodash/truncate";
import * as React from "react";
export var BrandFollowToast = function(param) {
    var brandName = param.brandName;
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "WEGw/a",
        defaultMessage: [
            {
                type: 0,
                value: "Following "
            },
            {
                type: 8,
                value: "MediumFormatting",
                children: [
                    {
                        type: 1,
                        value: "brandCompanyName"
                    }
                ]
            }
        ],
        values: {
            brandCompanyName: truncate(brandName, {
                length: 20
            }),
            MediumFormatting: MediumFormatting
        }
    });
};
var MediumFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(Medium, {
        children: chunks
    });
};
export var showBrandFollowToast = function(brandName) {
    createToast(/*#__PURE__*/ _jsx(BrandFollowToast, {
        brandName: brandName
    }), {
        timeout: "short"
    });
};
